import { Coupon } from '../models/coupon.model';
import { Cart } from '../models/cart.model';

export class CouponInitiation {
protected shoppingModel: Cart[];
protected couponCondition: Coupon[] | Coupon;
protected coupon: Coupon;
protected total: number;
protected qty: number
result: {
    isApplied: boolean,
    coupon: Coupon
}
finalResult: {
    type: string,
    offer: number,
    totalAmount: number
}
    constructor(couponCondition: Coupon[] | Coupon, shoppingCart: Cart[], coupon: Coupon, total: number, qty: number) {
        this.shoppingModel = shoppingCart;
        this.couponCondition = couponCondition;
        this.coupon = coupon;
        this.total = total;
        this.qty = qty;
    }
    protected couponCheckSwitch(fieldCondition: string, fieldValue: number, value: number) {
        if (fieldCondition === 'equal') {
          return fieldValue === value ? true : false;
        } else if (fieldCondition === 'greater than') {
          return fieldValue <= value ? true : false;
        } else if (fieldCondition === 'less than') {
          return fieldValue >= value ? true : false;
        }
      }
      checkCouponCondition() {
        if (Array.isArray(this.couponCondition)) { 
        const isCoupon = this.couponCondition.some(coupon => coupon.couponCode === this.coupon.couponCode);
        if (!isCoupon) return this.result= { isApplied: false, coupon: null };
        const coupon_condition = this.couponCondition.find(coupon => coupon.couponCode === this.coupon.couponCode);
        const hasConditionApplied = coupon_condition.field === 'Order total' ?  this.couponCheckSwitch(coupon_condition.fieldCondition, +coupon_condition.fieldValue, this.total) :
                                                                              this.couponCheckSwitch(coupon_condition.fieldCondition, +coupon_condition.fieldValue, this.qty);
        this.result = {
            isApplied: hasConditionApplied,
            coupon: coupon_condition
        }
        return this.result; 

        } else {
        const coupon_condition = this.couponCondition;
        const hasConditionApplied = coupon_condition.field === 'Order total' ?  this.couponCheckSwitch(coupon_condition.fieldCondition, +coupon_condition.fieldValue, this.total) :
                                                                              this.couponCheckSwitch(coupon_condition.fieldCondition, +coupon_condition.fieldValue, this.qty);    
         this.result = {
            isApplied: hasConditionApplied,
            coupon: coupon_condition
        }
        return this.result; 

        }
      }
      calculateCondition(defaultCondtion?: Coupon) {
          if (defaultCondtion) {
              this.result = {
                  isApplied: true,
                  coupon: defaultCondtion
              }
          }
          if (this.result.coupon.offerType === 'Flat') {
              this.finalResult = {
                  type: 'Flat',
                  offer: this.result.coupon.offer,
                  totalAmount: this.total - this.result.coupon.offer
              }
          } else {
              this.finalResult = {
                  type: 'Percentage',
                  offer: this.result.coupon.offer,
                  totalAmount: this.total - (this.total / 100 * this.result.coupon.offer | 0)
              }
          }
          return this.finalResult;
      }

}